import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { isValid as isValidCpf } from '@fnando/cpf';
import exact from 'prop-types-exact';
import Select from 'react-select';
import { Redirect } from 'react-router-dom';
import HeaderTags from '../../../common/headerTags/HeaderTags';
import Spinner from '../../../common/Spinner/Spinner';
// import ProfileImage from '../../../common/ProfileImage/ProfileImage';
import { showError, showInfo } from '../../../common/A1Alert/A1Alert';
import ShowPassword from '../../../common/showPassword/ShowPassword';
import ModalDeleteProfile from './ModalDeleteProfile';

/*
* This is the full registration form for editing the registration of the user (it is currently also the user profile screen)
* It is not the best name, but could not think of something better without refactoring everything....
*/

// @TODO improove the css! (use traditional flexbox and bootstrap stuff, like container, row and columns!)
// @TODO add all the validations

/** Note:
* Was decided to removed the option edit the email of the user
* This is a test to see how often the users change their email because we would have to add additional checks and integrations with firebase social logins
* to implement this properly...
* The users now have to get in contact with us if they want their email to be changed, so that we manually can verify the firebase auth integration...
*/

class RegistrationComponent extends Component {
    constructor(props) {
        super(props);

        const { user } = this.props;

        this.state = {
            user: user ? { ...user } : {},
            // originalEmail: user.get('email'), // edit user email is disabled for now (see comment more up)
            // emailConf: '', // edit user email is disabled for now (see comment more up)
            showPasswordFields: false,
            passwordNew: '',
            passwordNewConf: '',
            passwordOld: false, // currently disabled, as I don't think it is necessary and I don't know how to handle the facebook logged in users...
            somethingTouched: false,
            isOpenModalDeleteProfile: false,
            hasMounted: false,
        };

        this._handleInputChange = this._handleInputChange.bind(this);

        this._handleExtraInputChange = this._handleExtraInputChange.bind(this);

        this._handleSubmit = this._handleSubmit.bind(this);

        this._showPasswordFields = this._showPasswordFields.bind(this);
    }

    componentDidMount() {
        // isLoggedIn (derived from the jwt cookie) is only ever known on the client - the server
        // always renders as logged-out to keep the SSR HTML cacheable/generic - so the not-logged-in
        // redirect below must wait until after mount instead of happening during the initial render.
        this.setState({ hasMounted: true });

        if (!this.props.isLoggedIn) {
            return;
        }

        this.props.getStatesIfNeeded(); // I probably don't need the ifNeeded here, but who knows...

        if (this.state.user.stateId) {
            this.props.getCitiesIfNeeded(this.state.user.stateId);
        }

        // Note: This component is always unmounted when closed. So didMount is always called when opening
        this.props.getProfile();
    }

    componentDidUpdate(prevProps) {
        const currentUser = this.props.user;

        if (prevProps.user !== this.props.user && currentUser) {
            this.setState({ user: { ...currentUser } });

            if (currentUser.stateId) {
                this.props.getCitiesIfNeeded(currentUser.stateId);
            }
        }
    }

    _handleOpenModalDeleteProfile = (e) => {
        e.preventDefault();

        this.setState({
            isOpenModalDeleteProfile: true,
        });
    }

    _setIsOpenModalDeleteProfile = (value) => {
        this.setState({ isOpenModalDeleteProfile: value });
    };

    _handleDeleteProfileButton = () => {
        try {
            this.props.deleteProfile();

            window.location.href = '/';
        } catch (error) {
            return showError(error);
        }
    }

    _validateInputs() {
        const user = this.state.user;

        // Nome (can't be null, min 2 max 30 carateres)
        const trimmedName = user.name && user.name.trim && user.name.trim();

        if (!trimmedName || trimmedName.length < 2 || trimmedName.length > 30) {
            showError('O nome deve ter no mínimo 2 e no máximo 30 carateres');

            return false;
        }

        // Sobrenome (min 2 max 20 carateres)
        const trimmedLastName = user.lastName && user.lastName.trim && user.lastName.trim();

        if (user.lastName && user.lastName.length > 0 && (trimmedLastName.length < 2 || trimmedLastName.length > 30)) {
            showError('O sobrenome deve ter no mínimo 2 e no máximo 30 carateres');

            return false;
        }

        // CPF (validated via @fnando/cpf  plugin)
        if (user.cpf && user.cpf.length > 0 && !isValidCpf(user.cpf, true)) {
            showError('O CPF informado é inválido');

            return false;
        }

        // Aniversário (valid date, older than 4 and younger than 110)
        const age = Math.round((Date.now() - Date.parse(user.birthday)) / (1000 * 60 * 60 * 24 * 356));

        if (user.birthday && user.birthday.length > 0 && (!age || age < 4 || age > 110)) {
            showError('A data de nascimento informado é inválido');

            return false;
        }

        // CEP (9 digits, with '-')
        if (user.cep && user.cep.length > 0 && user.cep.length !== 9) {
            showError('O CEP informado é inválido');

            return false;
        }

        // Bairro (min 3 characters, max 30)
        const trimmedDistrict = user.district && user.district.trim && user.district.trim(0);

        // eslint-disable-next-line max-len
        if (user.district && user.district.length > 0 && (trimmedDistrict.length < 3 || trimmedDistrict.length > 30)) {
            showError('O bairro deve ter no mínimo 3 e no máximo 30 carateres');

            return false;
        }

        // Endereço (min 3 characters, max 30)
        const trimmedStreet = user.street && user.street.trim && user.street.trim();

        // eslint-disable-next-line max-len
        if (user.street && user.street.length > 0 && (trimmedStreet.length < 3 || trimmedStreet.length > 60)) {
            showError('O endereço deve ter no mínimo 3 e no máximo 60 carateres');

            return false;
        }

        // Complemento (max 30)
        if (user.addressSupplement && user.addressSupplement.length > 0 && user.addressSupplement.length > 30) {
            showError('O complemento deve ter no máximo 30 carateres');

            return false;
        }

        // Numero (not negative and not more than 5 digits)
        // eslint-disable-next-line max-len
        if (user.streetNumber && user.streetNumber.length > 0 && (user.streetNumber < 0 || user.streetNumber.length > 5)) {
            showError('O número do endereço deve ter no máximo 5 dígitos');

            return false;
        }

        // Telefone (14 or 15 digits (with symbols))
        // eslint-disable-next-line max-len
        if (user.telefone && user.telefone.length > 0 && (user.telefone.length !== 14 && user.telefone.length !== 15)) {
            showError('O telefone informado é inválido');

            return false;
        }

        /**
        * edit user email is disabled for now (see comment more up)

        // Email (can't be null and needs to be valid and not more than 40 characters)
        // eslint-disable-next-line max-len
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        // eslint-disable-next-line max-len
        if (!user.email || user.email.length <= 0 || user.email.match(emailRegex) == null || user.email.length > 40) {
            showError('O email é inválido');

            return false;
        }

        // Email (needs to be the same as conf)
        if (this.state.originalEmail !== user.email && user.email !== this.state.emailConf) {
            showError('Os emails estão diferentes');

            return false;
        }
        * */

        // Senha (min 6 caraters and needs to be the same as the conf)
        if (this.state.passwordNew && (this.state.passwordNew.length <= 0 || this.state.passwordNew.length < 6)) {
            showError('A senha deve ter no mínimo 6 carateres');

            return false;
        }

        // Senha (needs to be the same as conf)
        if (this.state.passwordNew && this.state.passwordNew !== this.state.passwordNewConf) {
            showError('As senhas estão diferentes');

            return false;
        }

        return true;
    }

    _handleInputChange(event) {
        const target = event.target;
        const name = target.name;
        const user = this.state.user;
        let value = target.type === 'checkbox' ? target.checked : target.value;

        if (window.safari) {
            if (name === 'birthday') {
                // as safari does not accept input date type and treat its data different
                // from other browsers, we need to pass it as a normal text and then change the date order.
                const splitted = value.split('/');

                if (splitted.length === 3) {
                    // we assume that the user inserted this value by hand and that it was on safari
                    value = `${splitted[2]}-${splitted[1]}-${splitted[0]}`;
                }
            }
        }

        if (name === 'stateId') {
            if (value) {
                // get the cities for the given state
                this.props.getCitiesIfNeeded(value);
            } else {
                // cleaning the cities so that they are not loaded the next time the modal is opened
                this.props.resetCities(); // Maybe better to keep the cities only in the local state and not in the store?
            }

            return this.setState({
                somethingTouched: true,
                user: {
                    ...user,
                    cityId: '',
                    stateId: value,
                },
            });
        }

        return this.setState({
            somethingTouched: true,
            user: {
                ...user,
                [name]: value,
            },
        });
    }

    _handleExtraInputChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({
            somethingTouched: true,
            [name]: value,
        });
    }

    _handleSubmit(event) {
        event.preventDefault();

        if (!this.state.somethingTouched) {
            return showInfo('Não há alterações realizadas');
        }

        if (!this._validateInputs()) {
            return false;
        }

        const user = this.state.user;

        /**
        * edit user email is disabled for now (see comment more up)

        if (!Object.is(user.email, this.state.originalEmail)) {
            // the email was changed
            // need the Object.is() function as it would compare for same reference with == or ===
            user.emailChanged = true;
        }
        */

        if (this.state.passwordNew !== '') {
            user.newPassword = this.state.passwordNew;

            // set a flag that the user needs to be logged off after changing the password
            return this.props.updateProfile(user, this.state.passwordOld, true);
        }

        return this.props.updateProfile(user, this.state.passwordOld);
    }

    _showPasswordFields(e) {
        e.preventDefault();

        this.setState({
            showPasswordFields: true,
        });
    }

    render() {
        const { user, showPasswordFields, somethingTouched, isOpenModalDeleteProfile, hasMounted } = this.state;
        const { isLoggedIn, submitting, states, cities, fetchingProfile } = this.props;

        if (hasMounted && !isLoggedIn) {
            // isLoggedIn is only known once mounted on the client (see componentDidMount) - the
            // server always renders as logged-out, so this must not redirect during SSR/first render
            return <Redirect to="/" />;
        }

        const isSafariBrowser = typeof window !== 'undefined' && window.safari;
        // const inputFieldError = somethingTouched && !codeValid;
        // const fieldClass = "inputCode"+ (inputFieldError && " inputErrorBox")
        // const disabled = !this._validateInputs() || submitting
        const disabled = !somethingTouched || submitting || isOpenModalDeleteProfile;

        const updatingCities = user.stateId && cities.length === 0;
        // const emailChanged = this.state.originalEmail !== user.email; // edit user email is disabled for now (see comment more up)
        // Date handle for safari input mask on user interface.
        let dateOnSafari = null;

        if (user.birthday) {
            const splittedDate = user.birthday.split('-');

            dateOnSafari = `${splittedDate[2]}/${splittedDate[1]}/${splittedDate[0]}`;
        }

        const customStyles = {
            container: (base) => ({
                ...base,
                width: '100%',
                height: '45px',
                maxWidth: '340px',
            }),
            control: (base) => ({
                ...base,
                borderRadius: 'none',
                height: '100%',
                borderColor: '#aaa',
                boxShadow: 'none',
                '&:hover': {
                    borderColor: '#aaa',
                },
            }),
            valueContainer: (base) => ({
                ...base,
                height: '100%',
            }),
            indicatorSeparator: () => ({
                color: 'transparent',
            }),
            menu: (base) => ({
                ...base,
                borderRadius: 'none',
                backgroundColor: '#fff',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            }),
            option: (base, { isFocused, isSelected }) => ({
                ...base,
                backgroundColor: isSelected ? '#F2F4F7' : isFocused ? '#F2F4F7' : '#fff',
                color: '#000',
                padding: '10px',
            }),
        };

        const selectGender = [
            {
                label: 'Feminino',
                value: 'FEMININO',
            },
            {
                label: 'Masculino',
                value: 'MASCULINO',
            },
        ]

        const stateOptions = states.map((state) => ({
            value: state.stateId,
            label: state.stateName.toUpperCase(),
        }));
        const cityOptions = cities.map((city) => ({
            value: city.cityId,
            label: (city.cityName || '').toUpperCase(),
        }));

        return (
            <section className="tw-container tw-m-auto">
                <HeaderTags
                    title="Meu perfil - Edite seus dados pessoais"
                    meta={{
                        description: 'Edite seus dados pessoais, endereço e senha da sua conta na Antena 1.',
                        robots: 'noindex, nofollow',
                    }}
                />
                <header>
                    <h2 className="tw-font-bold">Dados Pessoais</h2>
                </header>
                <div className="containerRegistration">
                    {fetchingProfile ?
                        <div className="registration-loading-placeholder">
                            <Spinner />
                        </div> :
                        <form className="formRegistration" onSubmit={this._handleSubmit}>
                            <div className="containerInput">
                                <div className="inputGroup">
                                    <label htmlFor="registrationName">Nome</label>
                                    <input
                                        className={`inputName${user.name ? '' : ' missing'}`}
                                        type="text"
                                        id="registrationName"
                                        name="name"
                                        value={user.name || ''}
                                        onChange={this._handleInputChange}
                                        autoComplete="name given-name"
                                        autoCapitalize="words"
                                    />
                                </div>

                                {/* campo sobrenome */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationLastName">Sobrenome</label>
                                    <input
                                        className={`inputLastName${user.lastName ? '' : ' missing'}`}
                                        type="text"
                                        id="registrationLastName"
                                        name="lastName"
                                        value={user.lastName || ''}
                                        onChange={this._handleInputChange}
                                        autoComplete="name additional-name"
                                        autoCapitalize="words"
                                    />
                                </div>

                                {/* campo E-mail */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationEmail">E-mail</label>
                                    <input
                                        className={`inputEmail${user.email ? '' : ' missing'}`}
                                        type="email"
                                        id="registrationEmail"
                                        name="email"
                                        autoComplete="email"
                                        value={user.email || ''}
                                        autoCapitalize="off"
                                        autoCorrect="off"
                                        disabled
                                    />
                                    <small>*Para alterar seu e-mail entre em contato conosco.</small>
                                </div>

                                {/* campo CPF */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationCpf">CPF</label>
                                    <InputMask
                                        className={`inputCPF${user.cpf ? '' : ' missing'}`}
                                        mask="999.999.999-99"
                                        placeholder="000.000.000-00"
                                        maskChar={null}
                                        type="tel"
                                        id="registrationCpf"
                                        name="cpf"
                                        autoComplete="off"
                                        value={user.cpf || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>
                                {/* campo data de nascimento */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationBirthday">Data de nascimento</label>
                                    {isSafariBrowser ?
                                        <InputMask
                                            className={`inputBirthday${user.birthday ? '' : ' missing'}`}
                                            mask="99/99/9999"
                                            placeholder="DD/MM/AAAA"
                                            id="registrationBirthday"
                                            name="birthday"
                                            autoComplete="bday"
                                            value={dateOnSafari || ''}
                                            onChange={this._handleInputChange}
                                            disabled
                                        />
                                        :
                                        <input
                                            className={`inputBirthday${user.birthday ? '' : ' missing'}`}
                                            type="date"
                                            id="registrationBirthday"
                                            placeholder="dd/mm/aaaa"
                                            name="birthday"
                                            autoComplete="bday"
                                            value={user.birthday || ''}
                                            onChange={this._handleInputChange}
                                        />}
                                </div>

                                {/* campo gênero */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationGender">Sexo</label>
                                    {/* <select
                                        className={`selectGender${user.gender ? '' : ' missing'}`}
                                        name="gender"
                                        id="registrationGender"
                                        value={user.gender || ''}
                                        onChange={this._handleInputChange}
                                    >
                                        <option value="">Sexo</option>
                                        <option value="MASCULINO">Masculino</option>
                                        <option value="FEMININO">Feminino</option>
                                </select> */}
                                    <Select
                                        className={`selectGender${user.gender ? '' : ' missing'}`}
                                        classNamePrefix="selectGender"
                                        name="gender"
                                        inputId="registrationGender"
                                        instanceId="registrationGender"
                                        styles={customStyles}
                                        options={selectGender}
                                        value={selectGender.find((option) => option.value === user.gender) || null}
                                        onChange={(selectedOption) => {
                                            this._handleInputChange({
                                                target: {
                                                    name: 'gender',
                                                    value: selectedOption ? selectedOption.value : '',
                                                },
                                            });
                                        }}
                                        placeholder="Sexo"
                                        isSearchable={false}
                                    />
                                </div>

                                {/* campo contato */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationTel">Telefone</label>
                                    <InputMask
                                        className={`inputTelefone${user.telefone ? '' : ' missing'}`}
                                        mask="(99) 99999-9999" // if there are problems, use the following plugin https://github.com/text-mask/text-mask
                                        placeholder="(00) 00000-0000"
                                        maskChar={null}
                                        type="tel"
                                        id="registrationTel"
                                        name="telefone"
                                        autoComplete="tel"
                                        value={user.telefone || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>
                                {/* campo CEP  */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationCep">CEP</label>
                                    <InputMask
                                        className={`inputCEP${user.cep ? '' : ' missing'}`}
                                        mask="99999-999"
                                        placeholder="00000-000"
                                        maskChar={null}
                                        type="tel"
                                        id="registrationCep"
                                        name="cep"
                                        autoComplete="off"
                                        value={user.cep || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>

                                {/* campo estado  */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationStateId">Estado</label>
                                    {/* <select
                                        className={`selectState${user.stateId ? '' : ' missing'}`}
                                        name="stateId"
                                        id="registrationStateId"
                                        value={user.stateId || ''}
                                        onChange={this._handleInputChange}
                                    >
                                        <option value="">Estado</option>
                                        {
                                            states.map((state) => (
                                                <option key={state.stateId} value={state.stateId || ''}>
                                                    {state.stateName.toUpperCase()}
                                                </option>
                                            ))
                                        }
                                </select> */}
                                    <Select
                                        className={`selectState${user.stateId ? '' : ' missing'}`}
                                        name="stateId"
                                        id="registrationStateId"
                                        instanceId="registrationStateId"
                                        value={stateOptions.find((option) => option.value === String(user.stateId)) || null}
                                        onChange={(selectedOption) => {
                                            this._handleInputChange({
                                                target: {
                                                    name: 'stateId',
                                                    value: selectedOption ? selectedOption.value : '',
                                                },
                                            });
                                        }}
                                        styles={customStyles}
                                        options={stateOptions}
                                        placeholder="Estado"
                                        isSearchable={false}
                                    />
                                </div>

                                {/* campo cidade  */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationCityId">Cidade</label>
                                    {
                                        updatingCities ?
                                            <div className="updatingCitiesContainer">
                                                Carregando, aguarde ...
                                            </div>
                                            :
                                            <Select
                                                className={`selectCity${!user.cityId ? ' missing' : ''}`}
                                                classNamePrefix="selectCity"
                                                name="cityId"
                                                inputId="registrationCityId"
                                                instanceId="registrationCityId"
                                                value={cityOptions.find((option) => option.value === user.cityId) || null}
                                                onChange={(selectedOption) => {
                                                    this._handleInputChange({
                                                        target: {
                                                            name: 'cityId',
                                                            value: selectedOption ? selectedOption.value : '',
                                                        },
                                                    });
                                                }}
                                                options={cityOptions}
                                                placeholder="Cidade"
                                                isDisabled={updatingCities}
                                                styles={customStyles}
                                                isSearchable={false}
                                            />
                                    }
                                </div>

                                {/* campo Bairro  */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationDistrict">Bairro</label>
                                    <input
                                        className={`inputDistrict${user.district ? '' : ' missing'}`}
                                        type="text"
                                        id="registrationDistrict"
                                        name="district"
                                        autoComplete="address-level4"
                                        value={user.district || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>

                                {/* campo Logradouro  */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationStreet">Endereço</label>
                                    <input
                                        className={`inputStreet${user.street ? '' : ' missing'}`}
                                        type="text"
                                        id="registrationStreet"
                                        name="street"
                                        autoComplete="street-address"
                                        value={user.street || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>

                                {/* campo Número  */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationNum">Número</label>
                                    <input
                                        className={`inputStreetNumber${user.streetNumber ? '' : ' missing'}`}
                                        type="number"
                                        id="registrationNum"
                                        name="streetNumber"
                                        autoComplete="off"
                                        value={user.streetNumber || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>

                                {/* campo Complemento */}
                                <div className="inputGroup">
                                    <label htmlFor="registrationAddressSupplement">Complemento</label>
                                    <input
                                        className="inputAddressSupplement"
                                        type="text"
                                        id="registrationAddressSupplement"
                                        name="addressSupplement"
                                        autoComplete="off"
                                        value={user.addressSupplement || ''}
                                        onChange={this._handleInputChange}
                                    />
                                </div>
                            </div>
                            <div className="containerNewsletter tw-mt-5">
                                <label className="newsletterLabel" htmlFor="newsletter">
                                    <input
                                        id="newsletter"
                                        name="newsletter"
                                        value="newsletter"
                                        type="checkbox"
                                        checked={!!user.newsletter}
                                        onChange={this._handleInputChange}
                                    />
                                    <span />
                                    <div className="newsletterText">
                                        Desejo saber tudo o que acontece no mundo da música.
                                    </div>
                                </label>
                            </div>
                            <button className="cta validate-2 remove-profile" type="button" onClick={this._handleOpenModalDeleteProfile}>
                                {submitting === 'deleteProfile' ? 'Excluindo...' : 'Desejo excluir minha conta'}
                            </button>
                            <div className="tw-mt-12">
                                {
                                    showPasswordFields &&
                                    <div className="containerPasswordNew">
                                        <div className="containerChangePassword">
                                            <div className="inputGroup">
                                                <ShowPassword
                                                    id="registerPassword"
                                                    name="passwordNew"
                                                    label="Nova senha"
                                                    value={this.state.passwordNew}
                                                    onChange={this._handleExtraInputChange}
                                                    className={`inputPasswordNew${this.state.passwordNew ? '' : ' missing'}`}
                                                />
                                                <span className="tw-text-[#777C86] tw-text-xs">Sua senha deve ter no mínimo 6 caracteres. Recomendamos usar letra maiúscula, letra minúscula, número, símbolo e no mínimo 8 caracteres.</span>
                                            </div>
                                            <div className="inputGroup">
                                                <ShowPassword
                                                    id="registerConfPassword"
                                                    name="passwordNewConf"
                                                    label="Confirmar sua senha"
                                                    value={this.state.passwordNewConf}
                                                    onChange={this._handleExtraInputChange}
                                                    className={`inputPasswordNewConf${this.state.passwordNewConf ? '' : ' missing'}`}
                                                />
                                            </div>
                                        </div>
                                        <div className="passwordNewUpdateMessage">Ao alterar a senha, você será desconectado. Será necessário efetuar o login novamente.</div>
                                    </div>
                                }
                            </div>
                            <div className="tw-flex tw-justify-evenly tw-mt-12">
                                <button type="button" className={`cta ${showPasswordFields ? 'showPwFieldsTextInactive' : 'showPwFieldsText'}`} onClick={this._showPasswordFields}>Alterar senha</button>
                                <button className="cta buttonSubmit" type="submit" disabled={disabled}>
                                    {submitting === 'updateProfile' ? 'Atualizando...' : 'Salvar'}
                                </button>
                            </div>
                        </form>}
                </div>
                {this.state.isOpenModalDeleteProfile && (
                    <ModalDeleteProfile
                        isOpenModal={this.state.isOpenModalDeleteProfile}
                        setIsOpenModal={this._setIsOpenModalDeleteProfile}
                        deleteProfile={this._handleDeleteProfileButton}
                    />
                )}
            </section>
        );
    }
}

RegistrationComponent.propTypes = exact({
    isLoggedIn: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    submitting: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
    fetchingProfile: PropTypes.bool.isRequired,
    updateProfile: PropTypes.func.isRequired,
    getProfile: PropTypes.func.isRequired,
    deleteProfile: PropTypes.func.isRequired,
    getStatesIfNeeded: PropTypes.func.isRequired,
    getCitiesIfNeeded: PropTypes.func.isRequired,
    resetCities: PropTypes.func.isRequired,
    states: PropTypes.arrayOf(PropTypes.shape({
        stateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        stateName: PropTypes.string,
    })),
    cities: PropTypes.arrayOf(PropTypes.shape({
        cityId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        cityName: PropTypes.string,
    })),
});

export default RegistrationComponent;
